import {mountStudio} from './main';
import {Partner} from './Partner';
mountStudio(false,Partner);
